module.exports = __webpack_public_path__ + "static/Stella-7f93797d5586a34fbea62e703a7451c0.jpg";